import logger from './logger';

export enum FbEvents {
  Purchase = 'Purchase',
  AddToCart = 'AddToCart',
  ViewContent = 'ViewContent',
  Lead = 'Lead',
  CompleteRegistration = 'CompleteRegistration'
}

export const pushFbEvent = (eventName: FbEvents) => {
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // fbq('track', eventName);
  } catch (error) {
    logger.error(`fbq tracking method failed for event ${eventName}`, error);
  }
};
